// 基础设置
export default [
  {
    path: '/404',
    component: resolve => require(['@/pages/404.vue'], resolve),
    meta: {
      title: '404'
    }
  },
  {
    path: '/403',
    component: resolve => require(['@/pages/403.vue'], resolve),
    meta: {
      title: '403'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/other.js